<template>
    <edit-base-template 
            v-on:update='updateItem()'
            v-on:create='createItem()'
            v-on:cancel='cancelEdit()'
            v-on:delete='deleteItem()'
            :item='item' 
            :errors='errors' 
            :title='formTitle()'
            :candelete='true'>
        
        <template v-slot:body>
            <div class="form-group">
                <label for='name'>{{ $t('translations.name') }}</label>
                <input type='text' v-model='item.name' class='form-control'>
            </div>

            <div class="form-group">
                <label for='name'>{{ $t('translations.user_csv_file') }}</label>
                <div class='dropbox'>
                    <input class="input-file" ref='file_upload' type='file' @change="file_update($event.target.files)">
                    <p>
                        Drag file here to begin<br> or click to browse
                    </p>
                </div>
                <div>Mandatory fields are: "email","nhs_number","forenames","surname","dob","gender","postcode"</div>
            </div>

            <div class="form-group" v-if='file.name'>
                <label for='name'>{{ $t('translations.uploaded_file') }}</label>
                <div class='d-flex flex-row'>
                    <p class='align-self-center pr-2'>{{ file.name }}</p>
                    <button class='btn btn-primary btn-sm' v-on:click='test'>Test</button>
                </div>
            </div>

            <div class="form-group" v-if='messages && messages.length'>
                <textarea class='form-control' style='height: 250px' v-model='message_text'>
                </textarea>
            </div>


            
        </template>

    </edit-base-template>
</template>

<script>
	export default {
        extends: app.base.editBase,
		props: [
		],
		data: function(){
			return {
                title: 'Cohort',
                event: "cohort",
                model: "cohort",
                elementname: "Cohort",
                route: '/api/v1/cohorts',
                forms: [],
                auto_tag: null,
                ug_assign: null,
                file: {
                    name: null
                },
                fileData: null,
                messages: [],
			};
		},
        
        computed: {
            icons() {
                return this.arrayToAutocomplete(this.$root.fontawesome);
            },
            authHeaders () {
                return {
                    'Authorization': axios.defaults.headers.common['Authorization'],
                    'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                }
            },
            message_text() {
                if(Array.isArray(this.messages)) {
                    return this.messages.join("\n");
                }
                return "";
            }
        },
        mounted() {
            
        },
        watch: {
            
        },
        methods: {
            getName() {
                return this.item.name;
            },
            resetItem() {
                this.item = {
                    name: "",
                };

                this.errors = [];
                this.originalData = JSON.parse(JSON.stringify(this.item));
            },
            test(event) {
                this.setLoading(true);
                var form = new FormData();
                form.append("csv", this.fileData);
                
                axios.post(this.route + '/test', form, {headers: {'Content-Type': 'multipart/form-data' }})
                    .then((res) => {
                        this.setLoading(false);
                        this.messages = res.data.messages;
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "test");
                    });
            },

            updateItem(event) {
                this.setLoading(true);
                var form = new FormData();
                form.append("csv", this.fileData);
                form.append("name", this.item.name);
                
                axios.post(this.route + '/' + this.item.id, form, {headers: {'Content-Type': 'multipart/form-data' }}).then((res) => {
                    //console.log(res.data);
                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.tBrandKey(this.elementname) + " " + this.getName() + " updated successfully."});
                    if(this.fileData) {
                        this.addNotification({type: "success", content: "You will receive an email when your user upload has completed."});
                    }
                    this.originalData = null;
                    this.closePanel(true);
                }).catch((error) => {
                    console.log("error: " + JSON.stringify(error, null, 2));
                    this.setLoading(false);
                    this.handleError(error, "update", this.event + "-list");
                    console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                    this.$refs.editScroller.scrollTop = 0;
                    console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                    this.messages = error.data.messages;
                });
            },

            createItem(event) {
                this.setLoading(true);
                var form = new FormData();
                form.append("csv", this.fileData);
                form.append("name", this.item.name);

                axios.post(this.route, form, {headers: {'Content-Type': 'multipart/form-data' }}).then((res) => {
                    this.originalData = JSON.parse(JSON.stringify(this.item));
                    this.setLoading(false);

                    this.addNotification({type: "success", content: this.tBrandKey(this.elementname) + " " + this.getName() + " created successfully."});
                    if(this.fileData) {
                        this.addNotification({type: "success", content: "You will receive an email when your user upload has completed."});
                    }
                    console.log(res.data);
                    this.item.id = res.data.id;
                    this.originalData = null;
                    this.closePanel(true);
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");
                    console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                    this.$refs.editScroller.scrollTop = 0;
                    console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                    this.messages = error.data.messages;
                });
            },
            file_update(files) {
                this.fileData = files[0];
                
                // use the 1st file from the list
                let reader = new FileReader();

                // Closure to capture the file information.
                reader.onload = (e) => {
                    this.file.data = e.target.result;
                    this.$refs.file_upload.value = null;
                };

                // Read in the image file as a data URL.
                this.file = {
                    "name": files[0].name,
                    "type": files[0].type,
                    "data": null,
                }
                reader.readAsText(files[0]);
            }
        }

    }
</script>

<!-- SASS styling -->
<style lang="scss">
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }
  
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }
  
  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }
  
  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>